import styled from 'styled-components';

import { ContentBanner } from '@xing-com/banner';
import { BOTTOM_BAR_HEIGHT } from '@xing-com/crate-jobs-constants';
import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceL, spaceM } from '@xing-com/tokens';

// z-index 201 is used to show this Banner on top of the regular search-alerts/banner
export const Banner = styled(ContentBanner)`
  gap: ${spaceM};
  padding: ${spaceL};
  min-height: ${BOTTOM_BAR_HEIGHT}px;
  z-index: 201;

  @media ${mediaConfined} {
    justify-content: center;
  }
`;
